module.exports = __webpack_public_path__ + "static/media/backgroundImage.577a0056.png";